import { StripeWrapper } from "../../../../..//services/stripe-wrapper";
import { LdsModal } from "../../../../../legl-ui/lds-modal";
import { LeglStripeComponent } from "../../../../../legl-ui/stripe-component";
import { post } from "../../../../../legl-ui/utils/fetch";

export class PayStripeComponent extends LeglStripeComponent {
  static get properties() {
    return {
      currentUrl: { attribute: "current-url" },
      companyName: { attribute: "company-name" },
      paymentIntentId: {},
      applicant_name: { state: true },
      paymentDetails: { attribute: false },
    };
  }

  async callback({ payment_method_id, cardActionError, stripeError }) {
    const legl_payment_instance_reference = this.getLeglPaymentReference();
    const res = await post(this.currentUrl, {
      body: JSON.stringify({
        payment_method_id,
        cardActionError,
        stripeError,
        legl_payment_instance_reference,
        payment_intent_id: this.paymentIntentId,
      }),
    });
    const contentType = res.headers.get("content-type");
    const resData =
      contentType.indexOf("application/json") !== -1
        ? await res.json()
        : await res.text();
    if (res.status === 400 && resData.error === "PAYMENT_CLOSED") {
      window.location.reload();
      return;
    }
    if (res.status === 400 && resData.session_terminated) {
      LdsModal.create({
        title: "Payment session expired",
        description:
          "This payment session became inactive and we were unable to process your payment. Please click the button to refresh the page and continue with your payment.",
        primaryButtonAttributes: {
          variant: "contained",
          colour: "primary",
          onClick: () => window.location.reload(),
          label: "Try again",
        },
        hideCloseBtn: true,
      });
    }
    this.handleResultResponse(resData);
  }

  handleClick() {
    this.applicant_name = this.getPayerName();
    super.handleClick();
  }

  handleResultResponse(response) {
    if (!StripeWrapper.isResponseSuccessful(response)) {
      if (this.collectPaymentRequest !== undefined) {
        this.collectPaymentRequest.complete("fail");
      }
      this.enablePaymentForm();
    } else if (response.requires_action) {
      if (this.collectPaymentRequest !== undefined) {
        this.collectPaymentRequest.complete("success");
      }
      this.handleAction(response.client_secret);
    } else if (response.success) {
      if (this.collectPaymentRequest !== undefined) {
        this.collectPaymentRequest.complete("success");
      }
      this.scrollToTopOfPage();
      if (window.isNewPayApp) {
        window.dispatchEvent(new CustomEvent("payment-completed"));
        this.enablePaymentForm();
      } else {
        this.showConfirmation(response.success_url);
      }
    } else {
      this.enablePaymentForm();
    }
  }

  // FUNCTIONS FROM stripeCard.js

  getLeglPaymentReference() {
    if (this.paymentDetails) {
      return this.paymentDetails.reference;
    }
    return document.querySelector("[data-payment-reference]").value;
  }

  getPayerName() {
    if (this.paymentDetails) {
      return `${this.paymentDetails.first_name} ${this.paymentDetails.last_name}`;
    }
    const firstNameInput = document.querySelector("#id_first_name");
    const lastNameInput = document.querySelector("#id_last_name");
    let fromName = `${firstNameInput.value} ${lastNameInput.value}`; // Get initial value.

    firstNameInput.addEventListener("keyup", () => {
      fromName = `${firstNameInput.value} ${lastNameInput.value}`;
    });

    lastNameInput.addEventListener("keyup", () => {
      fromName = `${firstNameInput.value} ${lastNameInput.value}`;
    });
    return fromName;
  }

  showConfirmation(successUrl) {
    /*
      Show the confirmation of payment to the user.
    */
    window.location.replace(successUrl);
  }

  scrollToTopOfPage() {
    window.scrollTo(0, 0);
  }
}

customElements.define("pay-stripe-component", PayStripeComponent);
